import React, { useContext, useState } from 'react';
import { FaRegHeart } from 'react-icons/fa';
import { Link, useParams } from 'react-router';
import { BASE_URL_API } from '../../References/URLs';
import AuthContext from '../../Store/AuthContext';
import styles from './EachProduct.module.css';

const EachProduct = (props) => {
    const { product, getCartItems, cartItems } = props;
    const { storeKey } = useParams();
    const authCtx = useContext(AuthContext);
    const loginData = authCtx?.loginData ? JSON.parse(authCtx.loginData) : null;
    const [isUpdating, setIsUpdating] = useState(false);

    // Check if the product is already in the cart
    const cartItem = cartItems.find((item) => item.productIdentifier === product.productIdentifier);

    // console.log('this is cart item : ', cartItem)

    const updateCart = async (direction) => {
        setIsUpdating(true);
        const updateCartResponse = await fetch(BASE_URL_API + "updateCart",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    cartItemIdentifier : cartItem.cartItemIdentifier,
                    direction: direction
                }),
            });

        if (!updateCartResponse.ok) {
            console.log("Something went wrong: Server Error");
        } else {
            const updateCartRespo = await updateCartResponse.json();
            if (updateCartRespo.status === "success") {
                getCartItems(); // Refresh cart items
            } else {
                if(updateCartRespo.message==='token Expired, please login again!') {
                    authCtx.logout()
                } else {
                    console.log(updateCartRespo.message);
                }
            }
        }
        setIsUpdating(false);
    };

    const addToCart = async () => {
        setIsUpdating(true)
        const addToCartResponse = await fetch(BASE_URL_API + "addToCart",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    userIdentifier: loginData.userIdentifier,
                    productIdentifier: product.productIdentifier
                })
            });

        if (!addToCartResponse.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const addToCartRespo = await addToCartResponse.json()
            if (addToCartRespo.status === "success") {
                getCartItems()
            } else {
                if(addToCartRespo.message==="token Expired, please login again!") {
                    authCtx.logout()
                }
            }
            console.log(addToCartRespo)
        }
        setIsUpdating(false)
    }


    const handleIncrease = () => {
        if (cartItem) {
            updateCart('increase');
        }
    };

    const handleDecrease = () => {
        updateCart('decrease')
    };

    return (
        <div className={styles.card}>
            <div className={styles.wishlistWrapper}>
                <FaRegHeart size={20} color="white" />
            </div>
            <Link to={`/shop/product/${product?.productIdentifier}`} className={styles.productThumbnailWrapper}>
                <img src={product?.productThumbnail || "https://dummyimage.com/sqrpop"} alt={product.productTitle} className={styles.image} />
            </Link>
            <div className={styles.details}>
                <div className={styles.dUpper}>
                    <div className={styles.productName}>{product.productTitle}</div>
                    <div className={styles.price}>₹{product.mrp}</div>
                </div>
                {product?.pointsOnSale !== null &&
                    <div className={styles.rewardPointsLine}>
                        <span className={styles.icon}>⭐</span>
                        Earn {product?.pointsOnSale} reward points!
                    </div>
                }
                <div className={styles.addToCartWrapper}>
                    {isUpdating ? (
                        <button className={styles.addToCartButton}>Updating...</button>
                    ) : cartItem ? (
                        <div className={styles.quantityControls}>
                            <button
                                className={styles.decreaseButton}
                                onClick={handleDecrease}
                                disabled={isUpdating}
                            >
                                -
                            </button>
                            <span className={styles.quantity}>{cartItem.quantity}</span>
                            <button
                                className={styles.increaseButton}
                                onClick={handleIncrease}
                                disabled={isUpdating}
                            >
                                +
                            </button>
                        </div>
                    ) : authCtx.isLoggedIn ? (
                        <button
                            className={styles.addToCartButton}
                            onClick={() => addToCart()}
                        >
                            Add to Cart
                        </button>
                    ) : (
                        <Link to={`/login?landingPage=${storeKey}/shop`}>Add To Cart</Link>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EachProduct;
